export default __webpack_public_path__ + "60922684df4e481b2e88f41f649b39ff.woff";